export const validColor = (valid) => {
    if (valid) return '#0E6D63';
    else if (valid === false) return '#EE6160';
    else return 'inherit';
}
export const validBackground = (valid) => {
    if (valid) return '#FFFFFF';
    else if (valid === false) return '#FDE7E7';
    else return '#FFFFFF';
}
export const darkBorder = (isDark) => {
    if (isDark) return "#2B2B2B";
    else if (isDark === false) return "rgba(43,43,43,.1)";
}
export const darkBackground = (isDark) => {
    if (isDark) return "#E5E4E5";
    else if (isDark === false) return "#FFFFFF";
}
export const darkFontColor = (isDark) => {
    if (isDark) return "#fff";
    else if (isDark === false) return "#2b2b2b";
}
